var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17 5.444 12 10m0 0L7 5.444M12 10V2m6 13.5H6c-2.58 0-2.58-3 0-3h12c2.58 0 2.58 3 0 3Zm0 6H6c-2.58 0-2.58-3 0-3h12c2.58 0 2.58 3 0 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad);
export default __webpack_public_path__ + "static/media/load.38bcc5b15e39a6ac9fcdf45c6dcb2a4e.svg";
export { ForwardRef as ReactComponent };